import { profile } from "../data/profile";

const SVG_NS = "http://www.w3.org/2000/svg";

function viewBoxFor(iconId: string): string {
  if (iconId === "ic-webrandum") return "20 10 160 160";
  if (iconId === "ic-note") return "-3 -3 30 30";
  return "0 0 24 24";
}

export function renderLink(mount: HTMLElement): void {
  const section = document.createElement("section");
  section.className = "page-section";

  const eyebrow = document.createElement("p");
  eyebrow.className = "page-eyebrow";
  eyebrow.textContent = "Link";

  const title = document.createElement("h2");
  title.className = "page-title";
  for (const [i, ch] of Array.from("またお会いしましょう").entries()) {
    const span = document.createElement("span");
    span.className = "page-title-char";
    span.textContent = ch;
    span.style.setProperty("--char-i", String(i));
    title.append(span);
  }

  const lead = document.createElement("p");
  lead.className = "page-lead";
  lead.textContent =
    "ふだん書いているところ・つぶやいているところ。お声がけ歓迎です。";

  const divider = document.createElement("hr");
  divider.className = "page-divider";

  const list = document.createElement("ul");
  list.className = "link-grid";

  for (const link of profile.links) {
    const li = document.createElement("li");
    const a = document.createElement("a");
    a.className = "link-card";
    a.href = link.url;
    a.target = link.url.startsWith("http") ? "_blank" : "_self";
    a.rel = "noopener noreferrer";

    const iconWrap = document.createElement("span");
    iconWrap.className = "link-card-icon";
    const svg = document.createElementNS(SVG_NS, "svg");
    svg.setAttribute("viewBox", viewBoxFor(link.iconId));
    svg.setAttribute("aria-hidden", "true");
    svg.setAttribute("focusable", "false");
    const use = document.createElementNS(SVG_NS, "use");
    use.setAttribute("href", `#${link.iconId}`);
    svg.append(use);
    iconWrap.append(svg);

    const body = document.createElement("div");
    body.className = "link-card-body";

    const key = document.createElement("span");
    key.className = "link-card-key";
    key.textContent = link.label;

    const handle = document.createElement("span");
    handle.className = "link-card-handle";
    handle.textContent = link.handle;

    const desc = document.createElement("span");
    desc.className = "link-card-desc";
    desc.textContent = link.description;

    body.append(key, handle, desc);
    a.append(iconWrap, body);
    li.append(a);
    list.append(li);
  }

  section.append(eyebrow, title, lead, divider, list);
  mount.append(section);
}
